import ClipboardButton from '~/components/ClipboardButton';
import DescriptionList, {
  DescriptionListItem,
} from '~/components/DescriptionList';
import LinkButton from '~/components/button/LinkButton';
import Page from '~/components/layout/page/Page';
import { CORSO_DEMO_REFERRER } from '~/utils/constants';
import { formatDate } from '~/utils/formatters';
import { useLoaderData } from './registrationOverview';

function RegistrationIncentiveSection() {
  const { formattedIncentive } = useLoaderData();

  if (!formattedIncentive) return null;

  const {
    code,
    message,
    isExpired,
    redemptionUrl,
    headline,
    isRedeemed,
    isActive,
    expiresOn,
  } = formattedIncentive;

  return (
    <Page.Section title={headline} subtitle={message ?? null}>
      <div
        className={`flex items-center gap-3 rounded-md border border-dashed p-3 ${
          isActive
            ? 'border-brand bg-brand-container'
            : 'border-outline-variant bg-surface-container opacity-75'
        }`}
      >
        <div className="flex min-w-0 flex-1 flex-col">
          <span className="label-sm text-on-surface-variant">
            Discount code
          </span>
          <span className="truncate font-mono text-sm tracking-wider text-on-surface">
            {code}
          </span>
        </div>
        <ClipboardButton
          onClick={() => code}
          accessibilityLabel="Copy discount code"
        />
      </div>

      {redemptionUrl && (
        <LinkButton to={redemptionUrl} variant="filled" target="_top">
          Redeem
        </LinkButton>
      )}

      {expiresOn && !isRedeemed && (
        <p className="body-sm text-on-surface-variant">
          {isExpired
            ? `Expired on ${formatDate(expiresOn)}`
            : `Expires on ${formatDate(expiresOn)}`}
        </p>
      )}
    </Page.Section>
  );
}

export default function RegistrationOverviewPage() {
  const {
    isStartWarrantyClaimEnabled,
    registration,
    referrer,
    storeUrl,
    isEmbedded,
    registrationSubmissionText,
  } = useLoaderData();

  const {
    externalId,
    createdOn,
    email,
    orderIdFromPlatform: idFromPlatform,
  } = registration;

  const isCorsoReferrer = referrer === CORSO_DEMO_REFERRER;

  const showActions =
    isCorsoReferrer || isStartWarrantyClaimEnabled || storeUrl;

  return (
    <Page.Root
      title="Registration Created"
      subtitle={registrationSubmissionText}
    >
      <Page.Section title="Confirmation">
        <DescriptionList divide>
          <DescriptionListItem label="Confirmation" value={`#${externalId}`} />
          <DescriptionListItem label="Email" value={email} />
          <DescriptionListItem label="Created" value={formatDate(createdOn)} />
        </DescriptionList>
      </Page.Section>

      <RegistrationIncentiveSection />

      {showActions && (
        <div className="flex flex-wrap justify-between gap-4 *:flex-1 *:whitespace-nowrap">
          {/* can we skip the hub and go straight to warranty here? */}
          {isStartWarrantyClaimEnabled && (
            <LinkButton
              variant="filled"
              // todo: this should go to the new request page, but the order page has the logic
              to={`../../order/${idFromPlatform}`}
            >
              Start A Claim
            </LinkButton>
          )}

          {isCorsoReferrer ? (
            <LinkButton
              to="https://www.corso.com/book-a-time"
              variant="outlined"
              target="_top"
            >
              Book A Time
            </LinkButton>
          ) : (
            storeUrl &&
            !isEmbedded && (
              <LinkButton to={storeUrl} variant="outlined">
                Back To Merchant
              </LinkButton>
            )
          )}
        </div>
      )}
    </Page.Root>
  );
}
